<template>
    <v-dialog v-model="dialogProp" width="500" scrollable>
        <v-card>
            <v-toolbar flat>
                <v-spacer />
                <v-btn icon @click="dialogProp = false">
                    <v-icon>{{ mdiClose }}</v-icon>
                </v-btn>
            </v-toolbar>
            <v-card-title>
                <h4>Emergency Care:</h4>
                <div>
                    <h6 style="word-break: break-word;">
                        For emergency cases, you may proceed directly to the nearest
                        hospital whether or not it is accredited by HMI.
                    </h6>
                </div>
            </v-card-title>
            <v-divider />

            <v-card-text>
                <!-- Benefits Affiliated -->
                <div class="benefits-affiliated">
                    <h3 style="word-break: break-word;">
                        Benefits Covered at HMI-Affiliated Hospitals:
                    </h3>
                    <v-divider />
                    <ul v-for="(benefit, i) in benefits" :key="i">
                        <li>{{ benefit }}</li>
                    </ul>
                </div>

                <!-- Benefits NON Affiliated -->
                <div class="benefits-non-affiliated">
                    <h3 style="word-break: break-word;">
                        Benefits Covered at Non-Affiliated Hospitals:
                    </h3>
                    <v-divider />
                    <h4 style="word-break: break-word;">
                        HMI will reimburse up to eighty percent (80%) of the total hospital
                        bills including professional fees based on HMI standard rates. This
                        reimbursement shall not exceed the maximum reimbursable amount
                        depending on the member’s program type. Coverage is per ER case, up
                        to the member’s Maximum Benefit Limit (MBL).
                    </h4>
                </div>
            </v-card-text>
        </v-card>
    </v-dialog>
</template>

<script>
import { mdiClose } from '@mdi/js'

export default {
    props: ['showEmergency'],

    data: () => ({
        mdiClose,
        benefits: [
            'Professional services of Emergency Room (ER) physicians.',
            'Medicines used during treatment excluding vaccines.',
            '	Oxygen and intravenous fluids.',
            'Dressing, sutures and casts (except fiberglass/non-plaster 	casts).',
            'Laboratory exams and diagnostic procedures.',
            'All other items directly related to the emergency/medical 	management of the patient. '
        ]
    }),
    computed: {
        dialogProp: {
            get() {
                return this.showEmergency
            },
            set(val) {
                this.$emit('showDialog', val)
            }
        }
    }
}
</script>

<style scoped>
ul li {
  font-size: 13px;
  padding-top: 10px;
  color: black;
}
.benefits-affiliated,
.benefits-non-affiliated,
.preventive,
.acu {
  padding-top: 20px;
}
.benefits-affiliated h3,
.benefits-non-affiliated h3,
.preventive h3,
.acu h3 {
  color: black;
  font-size: 20px;
}

.benefits-non-affiliated h4 {
  text-align: justify;
  padding-top: 10px;
  width: 95%;
  margin: auto;
  font-weight: normal;
  font-size: 12px;
  color: black;
}
.preventive h4,
.acu h4 {
  font-weight: normal;
  font-size: 13px;
  color: black;
  text-align: justify;
  padding-top: 10px;
}
h6 {
  font-weight: normal;
  font-size: 15px;
  color: black;
  line-height: 1.5em;
  width: 100%;
  padding: 0px 10px;
  margin: auto;
}
@media (max-width: 599px) {
  .benefits-affiliated h3,
  .benefits-non-affiliated h3 {
    line-height: 1.5em;
  }
  h6 {
    padding: 0px;
    line-height: 1.2em;
    font-size: 12.5px;
  }
}
</style>
